import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex" }

import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { computed, inject, ref } from 'vue';
import moment from 'moment';
import { IKWorkloadsPageData } from '@/views/workloads/workloads.injectionKeys';
import DatePicker from '@/components/date-picker/date-picker.vue';
import { useLicensePageLazyQuery } from '@/graphql/codegen/generated/graphql';
import { IKCoordinatorsService } from '@/modules/CoordinatorsService/CoordinatorService.InjectionKeys';
import { Constants } from '@/const/globals';
import { useOsService } from '@/services/OsService/OsService';
import { IKWorkloadsPersistentData } from '@/views/workloads/workloads-table.types';


export default /*#__PURE__*/_defineComponent({
  __name: 'workloadsTimeDurationSelect',
  setup(__props) {

const workloadsPageData = inject(IKWorkloadsPageData);
const workloadsPersistentData = inject(IKWorkloadsPersistentData);
const coordinatorsService = inject(IKCoordinatorsService);
const osService = useOsService();
const isUnix = computed(() => osService?.isUnix.value);
const isWindows = computed(() => osService?.isWindows.value);

const timeSelection = computed(() => ({
  from: moment(workloadsPageData?.filter?.getTimeFrame.value.startTime),
  to: moment(workloadsPageData?.filter?.getTimeFrame.value.endTime),
}));

const customFilter = computed(() => workloadsPersistentData?.getCustomFilter.value);

const showEnterpriseObservability = ref(false);
const GQL_useLicenseInfoQuery = useLicensePageLazyQuery(() => ({
  coordinatorId: coordinatorsService?.selectedCoordinator.value || '',
}));

if (isWindows.value) {
  GQL_useLicenseInfoQuery.onResult(licenseData => {
    showEnterpriseObservability.value =
      licenseData?.data?.ibManagerEntities?.license?.windows?.features?.productFeatures?.includes(Constants.LICENSE_FEATURES.ENTERPRISE_OBSERVABILITY) ||
      licenseData?.data?.ibManagerEntities?.license?.windows?.tierName?.toLocaleLowerCase().includes(Constants.TIERS.ENTERPRISE.toLowerCase()) ||
      false;
  });
  GQL_useLicenseInfoQuery.load();
}

const isFromDateValid = (date: string) => {
  const parsedDate = moment(date, 'YYYY/MM/DD', true);
  if (showEnterpriseObservability.value || isUnix.value) {
    return moment(parsedDate).isSameOrAfter(moment(workloadsPageData?.oldestBuildStartTime.value).subtract(1, 'days'));
  }
  // regular user is limited to 14 days
  return moment(parsedDate).isAfter(moment().subtract(14, 'days')) && moment(date).isBefore(moment().add(0, 'days'));
};

const isToDateValid = (date: string) => {
  // Specify the exact format of the date string 'YYYY/MM/DD'
  const parsedDate = moment(date, 'YYYY/MM/DD', true);

  return parsedDate.isBefore(moment());
};

const updatePayloadWithTimeSelection = (value: { from: moment.Moment; to: moment.Moment }) => {
  workloadsPersistentData?.setCustomFilter();
  workloadsPageData?.filter?.setTimeFrame([
    {
      from: value.from.unix() * 1000,
      to: value.to.unix() * 1000,
    },
  ]);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(DatePicker, {
          "days-presets": [0, 6, 13],
          "date-from-limitation-fn": isFromDateValid,
          "date-to-limitation-fn": isToDateValid,
          "model-value": _unref(timeSelection),
          "button-label-custom-time-frame": _unref(customFilter),
          "onUpdate:modelValue": updatePayloadWithTimeSelection
        }, null, 8, ["model-value", "button-label-custom-time-frame"])
      ])
    ]),
    _: 1
  }))
}
}

})